// extracted by css-extract-rspack-plugin
export default {"root":"PreviewEditMessage_root__AAysd","bold":"PreviewEditMessage_bold__f+3-Z"};